export default __webpack_public_path__ + "img/x-circle.55f5add5.svg";